var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"card-background":"#3b3a3d","title":"¡Ya puedes abonar fondos!","title-color":"white"}},[_c('p',{staticClass:"text-md",staticStyle:{"color":"white","opacity":"0.75","line-height":"1.5rem"}},[_vm._v(" Tu cuenta en la Red está lista para que puedas abonar fondos y realizar ¡tu primera inversión de impacto en RedGirasol! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }